import { useMemo } from 'react'
import { useIdleTimer } from 'react-idle-timer'

/**
 * @param onWarning - notify the user when idle timeout is close
 * @param onIdle - action to perform when the idle timeout fires
 * @param idleTime - number of minutes to wait before performing the idle action
 */
const useIdleTimeout = ({ onWarning, onIdle, idleTime = 60 }) => {
    const idleTimeout = useMemo(() => {
        return idleTime * 60 * 1000 // minutes to ms
    }, [idleTime])

    const idleTimer = useIdleTimer({
        timeout: idleTimeout,
        promptBeforeIdle: 30 * 1000, // show warning 30 seconds before the the idle action is about to fire
        onPrompt: onWarning,
        onIdle,
        debounce: 500,
    })

    return {
        idleTimer,
    }
}

export default useIdleTimeout
